import styled from "styled-components";

export const WrapperPieCharts = styled.div`
    display: flex;
    width: 100%;
    padding: 0.25rem; 

    @media(max-width: 1280px){
        flex-direction: column;
    }

    @media(min-width: 1280px){
        div.recharts-legend-wrapper{
            left: -50% !important;
        }
    }
`;

export const WrapperPieChartItem = styled.div`
    width: 100%;  
    align-items: center;
`;


export const PieChartItem = styled.div<{hiddenUl?: boolean}>`
    width: 100%;
    position: relative;
    height: 250px;
    justify-content: center;

    ${(props) => props.hiddenUl && `
        ul{ visibility: hidden; }
    `};
`;


export const HeaderPieChartItem = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding-right: 0.5rem;
`;


export const BadgeGrey = styled.span`
    background-color: var(--default-color-font);
    color: var(--grey-softer);
    font-size: 12px;
    font-weight:bold;
    padding: 3px 6px;
    border-radius: 2px;
`;
